import React, { useState } from "react";
import "./sidebar.scss";
import brandStore from "../../store/brandStore";
import { Button, styled, IconButton, Collapse, Divider } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import categoryStore from "../../store/categoryStore";
import authStore from "../../store/authStore";

// Icon
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { BRAND_IMAGE_URL } from "../../constant";

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const Sidebar = ({ isOpenSidebar, setIsOpenSidebar }) => {
  const navigate = useNavigate();
  const AuthStore = authStore();
  const BrandStore = brandStore();
  const CategoryStore = categoryStore();
  const [expandedWomenCategory, setExpandedWomenCategory] =
    React.useState(false);
  const [expandedMenCategory, setExpandedMenCategory] = useState(false);
  const [expandedKidsCategory, setExpandedKidsCategory] = useState(false);

  const handleCloseSidebar = () => {
    setIsOpenSidebar(false);
    window.scrollTo({ top: 0 });
  };

  return (
    <div
      className="sidebar"
      style={{
        position: "fixed",
        overflow: isOpenSidebar ? "hidden" : "inherit",
        top: 0,
        left: isOpenSidebar ? 0 : -170,
        width: isOpenSidebar ? "100%" : "0px",
      }}
    >
      <div className="sidebar-container">
        <div className="close-btn">
          <IconButton onClick={handleCloseSidebar}>
            <CloseIcon />
          </IconButton>
        </div>
        <div className="sign-up-sing-in">
          <div className="image-container">
            <img
              src={`${BRAND_IMAGE_URL}/${BrandStore.brand.brandLogo}`}
              alt=""
            />
          </div>

          {AuthStore.myUser ? (
            <p>
              {AuthStore.myUser.firstName} {AuthStore.myUser.lastName}
            </p>
          ) : (
            <Button
              className="btn"
              variant="outlined"
              onClick={() => navigate("/sign-in")}
            >
              <p>Sign In / Sign Up</p>
            </Button>
          )}
        </div>
        <div className="sidebar-menu">
          <div className="sidebar-main-item">
            <div className="main-title extra">
              <Link to="/" className="link" onClick={handleCloseSidebar}>
                <p>Home</p>
              </Link>
            </div>
          </div>
          {/* {CategoryStore.womenCategory && (
            <div className="sidebar-main-item">
              <div className="main-title">
                <Link
                  to="/shop/women"
                  className="link"
                  onClick={handleCloseSidebar}
                >
                  <p>Women</p>
                </Link>
                <ExpandMore
                  expand={expandedWomenCategory}
                  onClick={() => {
                    setExpandedWomenCategory(!expandedWomenCategory);
                    if (expandedMenCategory) setExpandedMenCategory(false);
                    if (expandedKidsCategory) setExpandedKidsCategory(false);
                  }}
                  aria-expanded={expandedWomenCategory}
                  aria-label="show more"
                >
                  <ExpandMoreIcon />
                </ExpandMore>
              </div>
              <div className="sidebar-sub-items">
                <Collapse
                  in={expandedWomenCategory}
                  timeout="auto"
                  unmountOnExit
                >
                  {CategoryStore.womenCategory.map((item) => (
                    <div className="sub-item-title" key={item._id}>
                      <Link
                        to={`/shop/women/${item.categoryName}/${item._id}`}
                        className="link"
                        onClick={handleCloseSidebar}
                      >
                        <p>{item.categoryName}</p>
                      </Link>
                    </div>
                  ))}
                </Collapse>
              </div>
            </div>
          )}
          {CategoryStore.menCategory && (
            <div className="sidebar-main-item">
              <div className="main-title">
                <Link
                  to="/shop/men"
                  className="link"
                  onClick={handleCloseSidebar}
                >
                  <p>Men</p>
                </Link>
                <ExpandMore
                  expand={expandedMenCategory}
                  onClick={() => {
                    setExpandedMenCategory(!expandedMenCategory);
                    if (expandedWomenCategory) setExpandedWomenCategory(false);
                    if (expandedKidsCategory) setExpandedKidsCategory(false);
                  }}
                  aria-expanded={expandedMenCategory}
                  aria-label="show more"
                >
                  <ExpandMoreIcon />
                </ExpandMore>
              </div>
              <div className="sidebar-sub-items">
                <Collapse in={expandedMenCategory} timeout="auto" unmountOnExit>
                  {CategoryStore.menCategory.map((item) => (
                    <div className="sub-item-title" key={item._id}>
                      <Link
                        to={`/shop/men/${item.categoryName}/${item._id}`}
                        className="link"
                        onClick={handleCloseSidebar}
                      >
                        <p>{item.categoryName}</p>
                      </Link>
                    </div>
                  ))}
                </Collapse>
              </div>
            </div>
          )}
          {CategoryStore.kidsCategory && (
            <div className="sidebar-main-item">
              <div className="main-title">
                <Link
                  to="/shop/kids"
                  className="link"
                  onClick={handleCloseSidebar}
                >
                  <p>Kids</p>
                </Link>
                <ExpandMore
                  expand={expandedKidsCategory}
                  onClick={() => {
                    setExpandedKidsCategory(!expandedKidsCategory);
                    if (expandedWomenCategory) setExpandedWomenCategory(false);
                    if (expandedMenCategory) setExpandedMenCategory(false);
                  }}
                  aria-expanded={expandedKidsCategory}
                  aria-label="show more"
                >
                  <ExpandMoreIcon />
                </ExpandMore>
              </div>
              <div className="sidebar-sub-items">
                <Collapse
                  in={expandedKidsCategory}
                  timeout="auto"
                  unmountOnExit
                >
                  {CategoryStore.kidsCategory.map((item) => (
                    <div className="sub-item-title" key={item._id}>
                      <Link
                        to={`/shop/kids/${item.categoryName}/${item._id}`}
                        className="link"
                        onClick={handleCloseSidebar}
                      >
                        <p>{item.categoryName}</p>
                      </Link>
                    </div>
                  ))}
                </Collapse>
              </div>
            </div>
          )} */}
          {AuthStore.isLogged && (
            <div className="user-menu">
              <Divider />
              <div className="sidebar-main-item">
                <div className="main-title extra">
                  <Link
                    to="/user"
                    className="link"
                    onClick={handleCloseSidebar}
                  >
                    <p>Account</p>
                  </Link>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div
        style={{ height: "100vh", width: "30%" }}
        onClick={() => setIsOpenSidebar(false)}
      ></div>
    </div>
  );
};

export default Sidebar;
